import React from 'react';
import footerLog from './../../images/ICON/logo.png'
const Footer = () => {
    return (
        <div>
            <section className='footer-part'> 
                <div className='container'>
                    <div className='row py-5'>
                        <div className='col-lg-8'>
                            <img src={footerLog} alt="" class="img-fluid" />
                        </div>
                        <div className='col-lg-2'>
                            <a href="#">About Online food</a>
                            <a href="#">Read our blog</a>
                            <a href="#">Sign up to deliver</a>
                            <a href="#">Add your resaurant </a>
                        </div>
                        <div className='col-lg-2'>
                            <a href="#">Get help</a>
                            <a href="#">Read FAQs</a>
                            <a href="#">View all cities</a>
                            <a href="#">Resaurant near me </a>
                        </div>
                    </div>

                    <div className='row py-5'>
                        <div className='col-lg-6 text-white'>
                            <p className='Copyight'>Copyight @ 2021 Online food</p>
                        </div>
                        <div className='col-lg-2'>
                            <a href="#">Privacy Policy</a>
                        </div>
                        <div className='col-lg-2'>
                            <a href="#">Terms of Use</a>
                        </div>
                        <div className='col-lg-2'>
                            <a href="#">Pricing</a>
                        </div>
                </div>
                </div>
            </section>
        </div>
    );
};

export default Footer;